'use strict';
var bannerPopupController = /** @class */ (function () {
    /*@ngInject*/
    function bannerPopupController($q, $log, $sce, bannerPopupService) {
        'ngInject';
        this.$q = $q;
        this._$log = $log;
        this.$sce = $sce;
        this.bannerPopupService = bannerPopupService;
        this.data = {};
        this.popupData = null;
    }
    bannerPopupController.prototype.$onInit = function () {
        var _this = this;
        this.bannerPopupService.getpopUpBannerService().then(function (response) {
            if (response && response.data) {
                _this.popupData = response.data.response;
            }
        });
    };
    bannerPopupController.prototype.openPopup = function (input) {
        if (input === 'open') {
            this.data = {
                popupClass: "show",
                desktopImageURL: this.popupData.desktopImageURL,
                mobileImageURL: this.popupData.mobileImageURL,
                title: this.$sce.trustAsHtml(this.popupData.title.replace("®", "<sup>®</sup>").replace("™", "<sup>™</sup>").replace("©", "<sup>©</sup>")),
                subTitle: this.$sce.trustAsHtml(this.popupData.subTitle.replace("®", "<sup>®</sup>").replace("™", "<sup>™</sup>").replace("©", "<sup>©</sup>")),
                descriptionText: this.$sce.trustAsHtml(this.popupData.descriptionText),
                ctaButtonText: this.popupData.ctaButtonText,
                ctaButtonLink: this.popupData.ctaButtonLink
            };
        }
        else {
            this.data = {};
        }
    };
    return bannerPopupController;
}());
export default bannerPopupController;
//# sourceMappingURL=bannerPopup.component.js.map